'use strict';

import React from 'react';

import { OnSchedUtils } from "../../utils";

import Title             from "../../components/Title/Title";
import List             from "../../components/List/List";


const Services = element => 
  <>
    <Title element={element} title={OnSchedUtils.Internationalize(element, 'consumer_services_title')}/>

    <List 
      image="imageUrl" 
      element={element} 
      event="clickService" 
      properties={
        element.options.properties
         ? element.options.properties
          : ['{name}', { 
            min: 'durationMin', 
            max: 'durationMax', 
            interval: 'durationInterval', 
            propertyName: 'duration', 
            dynamicTrigger: 'durationSelect', 
            value: OnSchedUtils.Internationalize(element, 'consumer_appointment_duration') 
          }]
      } 
    />
  </>

export default Services
